module.exports = __webpack_public_path__ + "img/icon_lock.ddc4879.svg";